import React from 'react';
import styled from 'styled-components';
import TrueImpactButton from './TrueImpactButton';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SPACERS } from '../settings/variables/Spacers';
import { COLORS } from '../settings/variables/Colors';

const StyledButton = styled.div`
  display: flex;
  gap: ${SPACERS.small};
  .rounded {
    width: 100%;
    border-radius: 50px;
    padding: ${SPACERS.small};
    border-color: transparent;
    transition: background 0.3s ease-in-out, color 0.3s ease-in-out;
    &:hover,
    &:hover svg {
      border-color: ${COLORS.blackPure};
      color: ${COLORS.ctaPrimaryBackground};
    }
    svg {
      width: 24px;
      color: ${COLORS.ctaPrimary};
      opacity: 0.7;
      margin-right: ${SPACERS.tiny};
    }
  }
`;

interface TrueImpactRoundButtonProps {
  icon?: IconProp;
  text?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick: () => unknown;
}

const TrueImpactRoundButton: React.FC<TrueImpactRoundButtonProps> = ({
  icon,
  text,
  style,
  className,
  onClick,
}) => {
  return (
    <StyledButton style={style} className={className}>
      <TrueImpactButton
        className="rounded"
        variant="icon-only-small"
        color="ctaPrimary"
        backgroundColor="whiteBase"
        backgroundColorHover="ctaPrimary"
        colorHover="whiteBase"
        onClick={onClick}
      >
        {icon && <FontAwesomeIcon icon={icon} />}
        {text}
      </TrueImpactButton>
    </StyledButton>
  );
};

export default TrueImpactRoundButton;
